module.exports = __webpack_public_path__ + "img/chat-box-big.9a46c314.webp";